import { API_URL } from "../config/config";
import { RequestFn } from "../api/useApi";
import { toError } from "../helpers/error.helper";

export const mediaService = {
  uploadImage,
};

export type UploadedImageResult = {
  imageUrl: string;
  blobName: string;
};

async function uploadImage(file: File, request: RequestFn): Promise<UploadedImageResult> {
  const formData = new FormData();
  formData.append("file", file);

  const res = await request(`${API_URL}/media/UploadImage`, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) throw await toError(res, "Failed to upload image");

  return res.json();
}
